import { Button, Grid, GridItem } from "@patternfly/react-core";
import { useControllerContext } from "@rhc-shared-components/control-wrapper";
import { useQueryClient } from "@tanstack/react-query";
import { type FC, useState } from "react";
import { useProductMetadata } from "../../hooks/useProductMetadata";
import { productListBaseQueryKey } from "../../queries/productList";
import { DeleteProductListingModal } from "../general/Modal/DeleteProductListingModal";
import { CheckList } from "./CheckList";
import { ProductContactDetails } from "./ProductContactDetails";
import { ProductScoreOverview } from "./ProductScoreOverview";
import { VVCertStatus } from "./VVCertStatus";

const ProductOverview: FC = () => {
	const queryClient = useQueryClient();
	const { productDetail } = useProductMetadata();
	const { certificationListState, isPartnerValidationSupported } = useProductMetadata();
	const initialDeleteModalState = {
		show: false,
	};
	const { isReadOnly } = useControllerContext();
	const [deleteModal, setDeleteModal] = useState(initialDeleteModalState);
	const handleDeleteModalCancel = () => setDeleteModal({ show: false });
	const handleDeleteModalOk = async () => {
		setDeleteModal({ show: false });
		await queryClient.invalidateQueries({ queryKey: productListBaseQueryKey });
	};
	return (
		<Grid hasGutter={true} data-analytics-category="Product Info|Tabs|Overview">
			<GridItem span={7} rowSpan={5}>
				{productDetail?.published ? <ProductScoreOverview /> : <CheckList />}
			</GridItem>
			<GridItem span={5}>
				<ProductContactDetails />
			</GridItem>
			{isPartnerValidationSupported && (
				<GridItem span={5}>
					<VVCertStatus />
				</GridItem>
			)}
			<GridItem>
				{!productDetail?.published && (
					<Button
						variant={"secondary"}
						isDisabled={isReadOnly}
						onClick={() => {
							setDeleteModal({ show: true });
						}}
					>
						Delete
					</Button>
				)}
			</GridItem>
			{deleteModal.show && (
				<DeleteProductListingModal
					certificationList={certificationListState}
					productDetail={productDetail}
					handleDeleteModalCancel={handleDeleteModalCancel}
					handleDeleteModalOk={handleDeleteModalOk}
				/>
			)}
		</Grid>
	);
};

export default ProductOverview;
